<template>
  <div class="controlPanel toolboxPage">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="工具箱" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: twoTabPaneValue == 'toolList' }"
            @click="twoTabPaneClick('toolList')"
            >工具列表</span
          >
          <span
            v-if="replacePartTabShow"
            class="childTabs"
            :class="{ activeLink: twoTabPaneValue == 'replacePart' }"
            @click="twoTabPaneClick('replacePart')"
            >更换包装配件SN<i
              class="el-icon-circle-close"
              @click.stop="closeReplacePartTab"
            ></i
          ></span>
          <span
            v-if="renovateTabShow"
            class="childTabs"
            :class="{ activeLink: twoTabPaneValue == 'renovate' }"
            @click="twoTabPaneClick('renovate')"
            >翻新拆解<i
              class="el-icon-circle-close"
              @click.stop="closeRenovateTab"
            ></i
          ></span>
          <span
            v-if="snReformTabShow"
            class="childTabs"
            :class="{ activeLink: twoTabPaneValue == 'snReform' }"
            @click="twoTabPaneClick('snReform')"
            >SN改制<i
              class="el-icon-circle-close"
              @click.stop="closeSnReformTab"
            ></i
          ></span>
          <span
            v-if="psdQueryTabShow"
            class="childTabs"
            :class="{ activeLink: twoTabPaneValue == 'psdQuery' }"
            @click="twoTabPaneClick('psdQuery')"
            >联想ODM<i
              class="el-icon-circle-close"
              @click.stop="closePsdQueryTab"
            ></i
          ></span>
          <div class="btnBox" v-if="twoTabPaneValue == 'psdQuery'">
            <div class="searchBtnBox" v-if="psdIsMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="psdReset"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="psdSearch">查询</el-button>
            </div>
            <el-dropdown size="small" @command="psdUploadCommand" style="margin-left: 8px;">
              <el-button type="primary" size="small" icon="el-icon-upload2">
                上传<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="psd">上传PSD</el-dropdown-item>
                <el-dropdown-item command="pbs">上传PBS</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown size="small" @command="psdSyncCommand" style="margin-left: 8px;">
              <el-button type="primary" size="small">
                手动同步<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="location">Location Mapping</el-dropdown-item>
                <el-dropdown-item command="inventory">Inventory</el-dropdown-item>
                <el-dropdown-item command="bom">BOM</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300" style="margin-left: 8px;">
              <el-button
                class="btn_more"
                :class="{ activeUserMore: psdIsMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="psdIsMoreSearch = !psdIsMoreSearch"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="contentBox">
      <!-- 工具列表 -->
      <div class="toolGrid" v-show="twoTabPaneValue == 'toolList'">
        <div
          class="toolCard"
          v-for="item in toolList"
          :key="item.id"
          @click="openTool(item)"
        >
          <i :class="['iconfont', item.icon]"></i>
          <div class="toolName">{{ item.name }}</div>
          <div class="toolDesc">{{ item.desc }}</div>
        </div>
      </div>
      <!-- 更换包装配件SN -->
      <div class="replacePartBox" v-show="twoTabPaneValue == 'replacePart'">
        <div class="topPanel">
          <div class="tips tipsBox">
            <span class="title">操作说明：</span>
            <span class="text">仅适用于电源适配器和电源线的部件SN更换！</span>
          </div>
          <div class="replacePartContent">
          <el-form
            :inline="true"
            :model="replacePartForm"
            class="demo-form-inline"
            :label-width="labelWidth"
          >
            <el-form-item key="partType" label="配件类型" size="small">
              <el-select
                v-model="replacePartForm.partType"
                placeholder="选择配件类型"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in partTypeList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item key="sn" label="产品SN" size="small">
              <el-input
                ref="replacePartKey"
                v-model="replacePartForm.sn"
                placeholder="请输入产品SN"
                clearable
                @keyup.enter.native="replacePartNext('sn')"
              ></el-input>
            </el-form-item>
            <el-form-item key="partSn" label="旧配件SN" size="small">
              <el-input
                ref="replacePartPartSn"
                v-model="replacePartForm.partSn"
                placeholder="请输入旧配件SN"
                clearable
                @keyup.enter.native="replacePartNext('partSn')"
              ></el-input>
            </el-form-item>
            <el-form-item key="newPartSn" label="新配件SN" size="small">
              <el-input
                ref="replacePartNewPartSn"
                v-model="replacePartForm.newPartSn"
                placeholder="请输入新配件SN"
                clearable
                @keyup.enter.native="replacePartEnterKeydown()"
              ></el-input>
            </el-form-item>
            <el-form-item size="small">
              <el-button type="primary" @click="replacePartEnterKeydown"
                >更换配件SN</el-button
              >
            </el-form-item>
          </el-form>
          <div
            class="statusBox"
            :class="[bindStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="bindStatus"
          >
            {{ bindStatus }}
          </div>
        </div>
        </div>
        <div class="tableBox">
          <el-table
            stripe
            :data="bindSNData"
            height="100%"
            border
            size="mini"
            style="width: 100%"
          >
            <el-table-column label="时间" align="center" min-width="80">
              <template slot-scope="scope">{{ scope.row.dateTime }}</template>
            </el-table-column>
            <el-table-column label="类别" align="center" min-width="80">
              <template slot-scope="scope">{{ scope.row.partType ? scope.row.partType : '-' }}</template>
            </el-table-column>
            <el-table-column label="产品SN" prop="sn" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.sn ? scope.row.sn : '-' }}</template>
            </el-table-column>
            <el-table-column label="旧配件SN" prop="partSn" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.partSn ? scope.row.partSn : '-' }}</template>
            </el-table-column>
            <el-table-column label="新配件SN" prop="newPartSn" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.newPartSn ? scope.row.newPartSn : '-' }}</template>
            </el-table-column>
            <el-table-column label="错误代码" prop="code" align="center" min-width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.code" style="color: #F56C6C">{{ scope.row.code }}</span>
                <span v-else>{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column label="错误信息" prop="msg" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.msg" :style="{ color: scope.row.code ? '#F56C6C' : '' }">{{ scope.row.msg }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 翻新拆解 -->
      <div class="replacePartBox" v-show="twoTabPaneValue == 'renovate'">
        <div class="topPanel">
          <div class="tips tipsBox">
            <span class="title">操作说明：</span>
            <span class="text">拆解旧SN的配件绑定关系，拆解后配件可用于其它主机的生产！</span>
          </div>
          <div class="replacePartContent">
          <el-form
            :inline="true"
            :model="renovateForm"
            class="demo-form-inline"
            :label-width="labelWidth"
          >
            <el-form-item key="sn" label="SN" size="small">
              <el-input
                ref="renovateKey"
                v-model="renovateForm.key"
                placeholder="请输入SN"
                clearable
                @keyup.enter.native="renovateEnterKeydown()"
              ></el-input>
            </el-form-item>
            <el-form-item size="small">
              <el-button type="primary" @click="renovateEnterKeydown"
                >翻新拆解</el-button
              >
            </el-form-item>
            <!-- 隐藏输入框：避免单输入框表单回车触发页面刷新 -->
            <input type="text" style="display:none;" />
          </el-form>
          <div
            class="statusBox"
            :class="[renovateStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="renovateStatus"
          >
            {{ renovateStatus }}
          </div>
        </div>
        </div>
        <div class="tableBox">
          <el-table
            stripe
            :data="renovateSNData"
            height="100%"
            border
            size="mini"
            style="width: 100%"
          >
            <el-table-column label="时间" align="center" min-width="80">
              <template slot-scope="scope">{{ scope.row.dateTime }}</template>
            </el-table-column>
            <el-table-column label="SN" prop="sn" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.sn ? scope.row.sn : '-' }}</template>
            </el-table-column>
            <el-table-column label="错误代码" prop="code" align="center" min-width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.code" style="color: #F56C6C">{{ scope.row.code }}</span>
                <span v-else>{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column label="错误信息" prop="msg" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.msg" :style="{ color: scope.row.code ? '#F56C6C' : '' }">{{ scope.row.msg }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- SN改制 -->
      <div class="replacePartBox" v-show="twoTabPaneValue == 'snReform'">
        <div class="topPanel">
          <div class="tips tipsBox">
            <span class="title">操作说明：</span>
            <span class="text">将SN切换成改制后的型号，用于重新生产！</span>
          </div>
          <div class="replacePartContent">
          <el-form
            :inline="true"
            :model="snReformForm"
            class="demo-form-inline"
            :label-width="labelWidth"
          >
            <el-form-item key="productType" label="产品类别" size="small">
              <el-select
                v-model="snReformForm.productType"
                placeholder="选择产品类别"
                filterable
                clearable
                @change="snReformProductTypeChange"
              >
                <el-option
                  v-for="(item, index) in snReformProductTypeList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item key="oldProductId" label="旧型号" size="small">
              <el-select
                v-model="snReformForm.oldProductId"
                placeholder="选择旧型号"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in snReformProductList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item key="newProductId" label="新型号" size="small">
              <el-select
                v-model="snReformForm.newProductId"
                placeholder="选择新型号"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in snReformProductList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item key="sn" label="SN" size="small">
              <el-input
                ref="snReformKey"
                v-model="snReformForm.sn"
                placeholder="请输入SN"
                clearable
                @keyup.enter.native="snReformSubmit()"
              ></el-input>
            </el-form-item>
            <el-form-item size="small">
              <el-button type="primary" @click="snReformSubmit"
                >改制</el-button
              >
            </el-form-item>
          </el-form>
          <div
            class="statusBox"
            :class="[snReformStatus == 'PASS' ? 'pass' : 'fail']"
            v-if="snReformStatus"
          >
            {{ snReformStatus }}
          </div>
        </div>
        </div>
        <div class="tableBox">
          <el-table
            stripe
            :data="snReformData"
            height="100%"
            border
            size="mini"
            style="width: 100%"
          >
            <el-table-column label="时间" align="center" min-width="80">
              <template slot-scope="scope">{{ scope.row.dateTime }}</template>
            </el-table-column>
            <el-table-column label="SN" prop="sn" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.sn ? scope.row.sn : '-' }}</template>
            </el-table-column>
            <el-table-column label="旧型号" prop="oldProductName" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.oldProductName ? scope.row.oldProductName : '-' }}</template>
            </el-table-column>
            <el-table-column label="新型号" prop="newProductName" align="center" min-width="100">
              <template slot-scope="scope">{{ scope.row.newProductName ? scope.row.newProductName : '-' }}</template>
            </el-table-column>
            <el-table-column label="错误代码" prop="code" align="center" min-width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.code" style="color: #F56C6C">{{ scope.row.code }}</span>
                <span v-else>{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column label="错误信息" prop="msg" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.msg" :style="{ color: scope.row.code ? '#F56C6C' : '' }">{{ scope.row.msg }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 联想ODM查询 -->
      <div class="psdQueryBox" v-show="twoTabPaneValue == 'psdQuery'">
        <input ref="psdFileInput" type="file" accept=".xlsx,.xls" @change="psdFileChange" style="display: none"/>
        <el-form :inline="true" :model="psdSearchForm" class="demo-form-inline" v-if="psdIsMoreSearch">
          <div class="searchConditionBox">
            <el-form-item label="fid" size="small">
              <el-input v-model="psdSearchForm.fid" placeholder="请输入fid" clearable @keyup.enter.native="psdSearch"></el-input>
            </el-form-item>
            <el-form-item label="类型" size="small">
              <el-select v-model="psdSearchForm.type" placeholder="请选择类型" clearable>
                <el-option label="ODM PSD" value="PSD"></el-option>
                <el-option label="ODM BPS&ETA" value="BPS&ETA"></el-option>
                <el-option label="ODM BOM" value="ODM BOM"></el-option>
                <el-option label="ODM Location" value="ODM Location"></el-option>
                <el-option label="ODM Inventory" value="ODM Inventory"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-input v-model="psdSearchForm.status" placeholder="请输入状态" clearable @keyup.enter.native="psdSearch"></el-input>
            </el-form-item>
            <el-form-item label="报告日期" size="small">
              <el-date-picker
                v-model="psdSearchForm.reportDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="错误代码" size="small">
              <el-input v-model="psdSearchForm.errorCode" placeholder="请输入错误代码" clearable @keyup.enter.native="psdSearch"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="tableBox">
          <el-table stripe :data="psdTableData" border height="100%" size="mini" style="width: 100%">
            <el-table-column label="类型" prop="type" align="center" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.type || '-' }}</template>
            </el-table-column>
            <el-table-column label="状态" prop="status" align="center" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.status || '-' }}</template>
            </el-table-column>
            <el-table-column label="错误代码" prop="errorCode" align="center" width="100">
              <template slot-scope="scope">
                <span :class="{ danger: scope.row.errorCode && scope.row.errorCode != 0 }">{{ scope.row.errorCode != null ? scope.row.errorCode : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="结果" prop="result" align="center" min-width="180">
              <template slot-scope="scope">
                <div class="bodyCell" v-if="scope.row.result">
                  <el-tooltip class="item" effect="dark" :content="scope.row.result" placement="top" :open-delay="300">
                    <div class="textOverflow">{{ scope.row.result }}</div>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    content="已将结果复制到剪贴板"
                    placement="top"
                    manual
                    v-model="scope.row.copyTipResult">
                    <i class="el-icon-document-copy copyBtn" title="复制" @click="copyText(scope.row, scope.row.result, 'copyTipResult')"></i>
                  </el-tooltip>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="上传人" align="center" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.uploader">{{ scope.row.uploader.employeeNum }}({{ scope.row.uploader.name }})</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="开始时间" prop="startDateTime" align="center" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.startDateTime || '待上传' }}</template>
            </el-table-column>
            <el-table-column label="完成时间" prop="completionDateTime" align="center" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.completionDateTime || '-' }}</template>
            </el-table-column>
            <el-table-column label="附件" align="center" min-width="150">
              <template slot-scope="scope">
                <div class="bodyCell" v-if="scope.row.file && scope.row.file.name">
                  <el-tooltip class="item" effect="dark" :content="scope.row.file.name" placement="top" :open-delay="300">
                    <div class="textOverflow">
                      <el-link type="primary" :underline="false" @click="psdDownloadFile(scope.row.file)">
                        {{ scope.row.file.name }}
                      </el-link>
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    content="已将文件名复制到剪贴板"
                    placement="top"
                    manual
                    v-model="scope.row.copyTipFileName">
                    <i class="el-icon-document-copy copyBtn" title="复制" @click="copyText(scope.row, scope.row.file.name, 'copyTipFileName')"></i>
                  </el-tooltip>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          :pagination="psdPagination"
          @currentChange="psdCurrentChange"
          @sizeChange="psdSizeChange"
          @refreshBtn="psdSearch"
        ></pagination>
      </div>
    </div>
    <!-- 工具卡片：点击工具按钮后以新卡片打开对应工具 -->
    <el-dialog
      :title="currentTool.name"
      :visible.sync="toolCardVisible"
      width="60%"
      top="8vh"
      custom-class="toolCardDialog"
    >
      <div class="toolCardBody">
        <!-- TODO: 后续根据 currentTool.id 渲染对应的工具组件，工具功能待完成 -->
        <div class="toolEmpty">
          <i class="iconfont icon-dakaidexiangzi"></i>
          <p>“{{ currentTool.name }}”功能开发中，敬请期待</p>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" @click="toolCardVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiCacheFlushAll } from "@/api/cacheApi.js";
import {
  apiReplacePartSnForce,
  apiAipcRenovateDisassemble,
  apiPartTypeList
} from "@/api/productSystem.js";
import {
  apiProductTypeList as apiSnReformProductTypeList,
  apiProductList as apiSnReformProductList,
  apiUpdateProductModel
} from "@/api/deviceManage.js";
import { apiLenovoPsdSearch, apiLenovoPsdUploadPsd, apiLenovoPsdUploadPbs, apiUploadFile, apiLenovoOdmSyncBom, apiLenovoOdmSyncInventory, apiLenovoOdmSyncLocation } from "@/api/filesUpload.js";
import pagination from "@/components/pagination.vue";
export default {
  components: {
    pagination
  },
  lastModuleConfig: { modulePath: "/homePage/toolbox", subTabs: { twoTabPaneValue: ["toolList", "replacePart", "renovate", "snReform", "psdQuery"] } },
  data() {
    return {
      // 工具列表，icon 使用 iconfont 图标；各工具具体功能待开发
      toolList: [
        { id: "productSystem", name: "生产系统", icon: "icon-shengchan", desc: "进入生产线作业员页面，可以进行：录像抽检、维修后目检、翻新拆解、更换配件SN等工序" },
        { id: "flushCache", name: "清理缓存", icon: "icon-qingkong", desc: "清除服务器缓存，让所有配置重新生效" },
        { id: "tool1", name: "更换配件SN", icon: "icon-genghuan", desc: "更换包装配件的SN（如：电源线、适配器等非组装配件）" },
        { id: "tool2", name: "翻新拆解", icon: "icon-jiebang", desc: "拆解旧SN的配件绑定关系，拆解后配件可用于其它主机的生产" },
        { id: "tool3", name: "SN改制", icon: "icon-zuzhiqiehuan", desc: "将SN切换成改制后的型号，用于重新生产" },
        { id: "lenovoPsd", name: "联想ODM报表", icon: "icon-Logo_Lenovo", desc: "请商务每天北京时间15:00前及时上传PSD、BPS报表；BOM、Location Mapping、Inventory报表会自动同步，不需要手动上传。" }
      ],
      toolCardVisible: false,
      currentTool: {},
      // 二级选项卡
      twoTabPaneValue: "toolList",
      // 更换包装配件SN选项卡是否打开
      replacePartTabShow: false,
      replacePartForm: {},
      partTypeList: [],
      bindStatus: null,
      bindMsg: null,
      // 执行结果表格
      bindSNData: [],
      // 翻新拆解选项卡是否打开
      renovateTabShow: false,
      renovateForm: {},
      renovateStatus: null,
      renovateMsg: null,
      // 翻新拆解执行结果表格
      renovateSNData: [],
      // SN改制选项卡是否打开
      snReformTabShow: false,
      snReformForm: { productType: null, oldProductId: null, newProductId: null, sn: '' },
      snReformStatus: null,
      snReformMsg: null,
      // SN改制下拉数据
      snReformProductTypeList: [],
      snReformProductList: [],
      // SN改制执行结果表格
      snReformData: [],
      // 联想ODM查询选项卡是否打开
      psdQueryTabShow: false,
      psdUploading: false,
      psdUploadType: null,
      psdIsMoreSearch: false,
      psdSearchForm: { fid: '', type: '', status: '', reportDate: [], errorCode: '' },
      psdTableData: [],
      psdPagination: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
        beginIndex: 0,
        endIndex: 0
      },
      labelWidth: "110px",
    };
  },
  methods: {
    // 新卡片打开对应工具
    openTool(tool) {
      // 生产系统：跳转独立的生产系统页面
      if (tool.id === "productSystem") {
        this.$router.push("/productSystem");
        return;
      }
      // 清理缓存：保留原有的简单确认弹框
      if (tool.id === "flushCache") {
        this.flushCache();
        return;
      }
      // 更换包装配件SN：在“工具列表”旁新开选项卡
      if (tool.id === "tool1") {
        this.openReplacePartTab();
        return;
      }
      // 翻新拆解：在“工具列表”旁新开选项卡
      if (tool.id === "tool2") {
        this.openRenovateTab();
        return;
      }
      // SN改制：在“工具列表”旁新开选项卡
      if (tool.id === "tool3") {
        this.openSnReformTab();
        return;
      }
      // 联想ODM：在“工具列表”旁新开选项卡
      if (tool.id === "lenovoPsd") {
        this.openPsdQueryTab();
        return;
      }
      this.currentTool = tool;
      this.toolCardVisible = true;
    },
    // 二级选项卡切换
    twoTabPaneClick(value) {
      this.twoTabPaneValue = value;
      if (value === "replacePart") {
        this.bindStatus = null;
        this.$nextTick(() => {
          this.$refs.replacePartKey && this.$refs.replacePartKey.focus();
        });
      }
      if (value === "renovate") {
        this.renovateStatus = null;
        this.$nextTick(() => {
          this.$refs.renovateKey && this.$refs.renovateKey.focus();
        });
      }
      if (value === "snReform") {
        this.snReformStatus = null;
        this.$nextTick(() => {
          this.$refs.snReformKey && this.$refs.snReformKey.focus();
        });
      }
    },
    // 打开更换包装配件SN选项卡
    openReplacePartTab() {
      this.replacePartTabShow = true;
      this.twoTabPaneClick("replacePart");
      this.getPartTypeList();
    },
    // 关闭更换包装配件SN选项卡
    closeReplacePartTab() {
      this.replacePartTabShow = false;
      this.twoTabPaneValue = "toolList";
      this.replacePartForm = {};
      this.bindStatus = null;
      this.bindMsg = null;
      this.bindSNData = [];
    },
    // 获取配件类型列表
    async getPartTypeList() {
      const res = await apiPartTypeList();
      if (res.code == 0) {
        this.partTypeList = res.data;
      }
    },
    // 更换包装配件SN--回车跳转下一输入框
    replacePartNext(currentField) {
      let fieldMap = {
        'sn': { next: 'replacePartPartSn', msg: '【产品SN】不能为空！' },
        'partSn': { next: 'replacePartNewPartSn', msg: '【旧配件SN】不能为空！' }
      };
      let cfg = fieldMap[currentField];
      let val = this.replacePartForm[currentField] ? this.replacePartForm[currentField].trim() : '';
      if (!val) {
        this.$message({ type: 'warning', message: cfg.msg });
        return;
      }
      this.$refs[cfg.next].focus();
      this.$refs[cfg.next].select();
    },
    // 更换包装配件SN--提交校验
    replacePartEnterKeydown() {
      if (!this.replacePartForm.sn || !this.replacePartForm.partSn || !this.replacePartForm.newPartSn) {
        this.$message({ type: 'warning', message: '所有SN不能为空！' });
        return;
      }
      let sn = this.replacePartForm.sn.trim();
      let partSn = this.replacePartForm.partSn.trim();
      let newPartSn = this.replacePartForm.newPartSn.trim();
      if (!sn || !partSn || !newPartSn) {
        this.$message({ type: 'warning', message: '所有SN不能为空！' });
        return;
      }
      this.replacePartSubmit();
    },
    // 更换包装配件SN--提交
    async replacePartSubmit() {
      let res = await apiReplacePartSnForce({
        sn: this.replacePartForm.sn,
        partType: this.replacePartForm.partType,
        partSn: this.replacePartForm.partSn,
        newPartSn: this.replacePartForm.newPartSn,
      });
      this.getBindSNData(res);
      if (res.code == 0) {
        this.$message({ type: 'success', message: res.msg || '更换配件SN成功' });
        this.bindStatus = 'PASS';
        this.bindMsg = res.msg;
        this.replacePartForm = {};
      } else {
        this.bindStatus = 'FAIL';
        this.bindMsg = res.msg;
      }
      this.$refs.replacePartKey.focus();
      this.$refs.replacePartKey.select();
    },
    // 记录执行结果
    getBindSNData(res) {
      // 配件类型编码转名称
      let partTypeName = "";
      this.partTypeList.forEach((item) => {
        if (item.code == this.replacePartForm.partType) {
          partTypeName = item.title;
        }
      });
      this.bindSNData.unshift({
        dateTime: new Date().toLocaleString(),
        partType: partTypeName,
        sn: this.replacePartForm.sn,
        partSn: this.replacePartForm.partSn,
        newPartSn: this.replacePartForm.newPartSn,
        code: res.code,
        msg: res.msg
      });
    },
    // 打开翻新拆解选项卡
    openRenovateTab() {
      this.renovateTabShow = true;
      this.twoTabPaneClick("renovate");
    },
    // 关闭翻新拆解选项卡
    closeRenovateTab() {
      this.renovateTabShow = false;
      this.twoTabPaneValue = "toolList";
      this.renovateForm = {};
      this.renovateStatus = null;
      this.renovateMsg = null;
      this.renovateSNData = [];
    },
    // 翻新拆解--回车提交
    renovateEnterKeydown() {
      if (!this.renovateForm.key) {
        return;
      }
      let tmp = this.renovateForm.key.trim();
      if (!tmp || tmp == "") {
        this.$message({
          type: "warning",
          message: `【SN】不能为空！`,
        });
        return;
      }
      if (tmp.startsWith("*AIPC_") && tmp.endsWith("*")) {
        this.$prompt('请扫描产品标签', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(async ({ value }) => {
          this.renovateForm["errorCode"] = this.renovateForm["key"];
          this.renovateForm["key"] = value;
          setTimeout(() => {
            this.renovateForm["errorCode"] = null;
          }, 1000);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
          return;
        });
      } else {
        this.renovateSubmit();
      }
    },
    // 翻新拆解--提交
    async renovateSubmit() {
      let res = await apiAipcRenovateDisassemble({
        ...this.renovateForm,
      });
      if (res.code == 0) {
        this.$message({ type: 'success', message: res.msg || '翻新拆解成功' });
        this.renovateStatus = 'PASS';
        this.renovateMsg = res.msg;
        this.getRenovateSNData(res);
        this.renovateForm = {};
      } else {
        this.renovateStatus = 'FAIL';
        this.renovateMsg = res.msg;
        this.getRenovateSNData(res);
      }
      this.$refs.renovateKey.focus();
      this.$refs.renovateKey.select();
    },
    // 记录翻新拆解执行结果
    getRenovateSNData(res) {
      this.renovateSNData.unshift({
        dateTime: new Date().toLocaleString(),
        sn: this.renovateForm.key,
        code: res.code,
        msg: res.msg
      });
    },
    // 打开SN改制选项卡
    openSnReformTab() {
      this.snReformTabShow = true;
      this.twoTabPaneClick("snReform");
      this.getSnReformProductTypeList();
    },
    // 关闭SN改制选项卡
    closeSnReformTab() {
      this.snReformTabShow = false;
      this.twoTabPaneValue = "toolList";
      this.snReformForm = { productType: null, oldProductId: null, newProductId: null, sn: '' };
      this.snReformStatus = null;
      this.snReformMsg = null;
      this.snReformData = [];
      this.snReformProductList = [];
    },
    // SN改制--产品类别下拉数据
    async getSnReformProductTypeList() {
      const res = await apiSnReformProductTypeList();
      if (res.code == 0) {
        this.snReformProductTypeList = res.data;
      }
    },
    // SN改制--产品类别改变，联动加载产品型号
    snReformProductTypeChange(value) {
      this.snReformForm.oldProductId = null;
      this.snReformForm.newProductId = null;
      this.snReformProductList = [];
      if (value) {
        this.getSnReformProductList(value);
      }
    },
    // SN改制--产品型号下拉数据
    async getSnReformProductList(productType) {
      const res = await apiSnReformProductList({ productType });
      if (res.code == 0) {
        this.snReformProductList = res.data;
      }
    },
    // SN改制--提交
    async snReformSubmit() {
      if (!this.snReformForm.productType) {
        this.$message({ type: 'warning', message: '请选择产品类别！' });
        return;
      }
      if (!this.snReformForm.oldProductId) {
        this.$message({ type: 'warning', message: '请选择旧型号！' });
        return;
      }
      if (!this.snReformForm.newProductId) {
        this.$message({ type: 'warning', message: '请选择新型号！' });
        return;
      }
      if (!this.snReformForm.sn || !this.snReformForm.sn.trim()) {
        this.$message({ type: 'warning', message: '【SN】不能为空！' });
        return;
      }
      const res = await apiUpdateProductModel({
        newProductId: this.snReformForm.newProductId,
        oldProductId: this.snReformForm.oldProductId,
        sn: this.snReformForm.sn.trim()
      });
      this.getSnReformData(res);
      if (res.code == 0) {
        this.$message({ type: 'success', message: res.msg || 'SN改制成功' });
        this.snReformStatus = 'PASS';
        this.snReformMsg = res.msg;
        this.snReformForm = { productType: this.snReformForm.productType, oldProductId: this.snReformForm.oldProductId, newProductId: this.snReformForm.newProductId, sn: '' };
      } else {
        this.snReformStatus = 'FAIL';
        this.snReformMsg = res.msg;
      }
      this.$refs.snReformKey.focus();
      this.$refs.snReformKey.select();
    },
    // 记录SN改制执行结果
    getSnReformData(res) {
      // 产品型号ID转名称
      let oldProductName = '';
      let newProductName = '';
      this.snReformProductList.forEach((item) => {
        if (item.id == this.snReformForm.oldProductId) {
          oldProductName = item.name;
        }
        if (item.id == this.snReformForm.newProductId) {
          newProductName = item.name;
        }
      });
      this.snReformData.unshift({
        dateTime: new Date().toLocaleString(),
        sn: this.snReformForm.sn,
        oldProductName: oldProductName,
        newProductName: newProductName,
        code: res.code,
        msg: res.msg
      });
    },
    // 打开联想ODM查询选项卡
    openPsdQueryTab() {
      this.psdQueryTabShow = true;
      this.twoTabPaneClick("psdQuery");
      this.psdSearch();
    },
    // 关闭联想ODM查询选项卡
    closePsdQueryTab() {
      this.psdQueryTabShow = false;
      this.twoTabPaneValue = "toolList";
      this.psdSearchForm = { fid: '', type: '', status: '', reportDate: [], errorCode: '' };
      this.psdTableData = [];
      this.psdPagination = { currentPage: 1, pageSize: 40, total: 0, beginIndex: 0, endIndex: 0 };
    },
    // 联想ODM--查询
    async psdSearch() {
      const params = {
        ...this.psdSearchForm,
        pageNum: this.psdPagination.currentPage,
        pageSize: this.psdPagination.pageSize
      };
      // 处理日期范围
      if (this.psdSearchForm.reportDate && this.psdSearchForm.reportDate.length === 2) {
        params.startDate = this.psdSearchForm.reportDate[0];
        params.endDate = this.psdSearchForm.reportDate[1];
      }
      delete params.reportDate;
      const res = await apiLenovoPsdSearch(params);
      if (res.code == 0) {
        this.psdTableData = res.data || [];
        this.psdPagination.total = res.total || 0;
        this.psdPagination.beginIndex = res.beginIndex || 0;
        this.psdPagination.endIndex = res.endIndex || 0;
      }
    },
    // 联想ODM--重置查询条件
    psdReset() {
      this.psdSearchForm = { fid: '', type: '', status: '', reportDate: [], errorCode: '' };
      this.psdPagination.currentPage = 1;
      this.psdSearch();
    },
    // 联想ODM--页码改变
    psdCurrentChange(val) {
      this.psdPagination.currentPage = val;
      this.psdSearch();
    },
    // 联想ODM--每页条数改变
    psdSizeChange(val) {
      this.psdPagination.pageSize = val;
      this.psdPagination.currentPage = 1;
      this.psdSearch();
    },
    // 联想ODM--下载文件
    psdDownloadFile(file) {
      if (file && file.id) {
        this.$downloadFile(file.id, file.name, file.secret);
      }
    },
    // 联想ODM--手动同步下拉命令
    psdSyncCommand(command) {
      const map = {
        location: { name: 'Location Mapping', api: apiLenovoOdmSyncLocation },
        inventory: { name: 'Inventory', api: apiLenovoOdmSyncInventory },
        bom: { name: 'BOM', api: apiLenovoOdmSyncBom }
      };
      const item = map[command];
      if (!item) return;
      this.$confirm(`是否确认手动同步 ${item.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await item.api();
        this.$message({ type: res.code == 0 ? 'success' : 'error', message: res.msg || (res.code == 0 ? '同步成功' : '同步失败') });
        this.psdSearch();
      }).catch(() => {});
    },
    // 联想ODM--上传下拉命令
    psdUploadCommand(command) {
      this.psdUploadType = command;
      this.$refs.psdFileInput.click();
    },
    // 联想ODM--上传
    psdUpload() {
      if (this.psdUploading) return;
      this.$refs.psdFileInput.click();
    },
    async psdFileChange() {
      if (this.psdUploading) return;
      const files = this.$refs.psdFileInput.files;
      if (!files || !files.length) return;
      const file = files[0];
      const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
      if (ext !== '.xlsx' && ext !== '.xls') {
        this.$message({ type: 'warning', message: '只能上传Excel文件（.xlsx / .xls）' });
        this.$refs.psdFileInput.value = '';
        return;
      }
      this.psdUploading = true;
      this.$refs.psdFileInput.value = '';
      const fd = new FormData();
      fd.append('file', file);
      try {
        const res = await apiUploadFile(fd);
        if (res.code == 0) {
          const uploadApi = this.psdUploadType === 'psd' ? apiLenovoPsdUploadPsd : apiLenovoPsdUploadPbs;
          const resUpload = await uploadApi({ id: res.fid });
          const typeName = this.psdUploadType === 'psd' ? 'PSD' : 'PBS';
          this.$message({ type: resUpload.code == 0 ? 'success' : 'error', message: resUpload.msg || (resUpload.code == 0 ? `${typeName}上传成功` : `${typeName}上传失败`) });
        }
        this.psdSearch();
      } catch (e) {
        this.psdSearch();
      } finally {
        this.psdUploading = false;
        this.psdUploadType = null;
      }
    },
    // 复制文本到剪贴板（tipField：控制对应列气泡提示的字段名）
    copyText(row, text, tipField) {
      const val = text || "";
      this._copyTimers = this._copyTimers || {};
      const showTip = () => {
        this.$set(row, tipField, true);
        clearTimeout(this._copyTimers[tipField]);
        this._copyTimers[tipField] = setTimeout(() => {
          this.$set(row, tipField, false);
        }, 1500);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(val).then(showTip);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = val;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        showTip();
      }
    },
    // 清理缓存
    flushCache() {
      this.$confirm("缓存能减轻数据库访问压力，清除后将重新加载缓存！", "清理缓存", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCacheFlushAll({});
        this.$message({
          message: res.msg,
          type: res.code == 0 ? "success" : "error"
        });
      });
    },
    // 刷新/重新进入后，记忆恢复的二级Tab需同步显示对应标签并补加载下拉数据
    // （twoTabPaneValue 由 lastModuleMixin 持久化恢复，但 *TabShow 标志未持久化，需在此对齐）
    restoreSubTab() {
      switch (this.twoTabPaneValue) {
        case "replacePart":
          this.replacePartTabShow = true;
          if (!this.partTypeList.length) this.getPartTypeList();
          break;
        case "renovate":
          this.renovateTabShow = true;
          break;
        case "snReform":
          this.snReformTabShow = true;
          if (!this.snReformProductTypeList.length) this.getSnReformProductTypeList();
          break;
        case "cfcUpload":
          this.cfcUploadTabShow = true;
          break;
        case "psdQuery":
          this.psdQueryTabShow = true;
          this.psdSearch();
          break;
      }
    },
  },
  activated() {
    // 恢复记忆中的二级Tab（需在 lastModuleMixin 恢复 twoTabPaneValue 之后执行）
    this.restoreSubTab();
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
  },
  deactivated() {
    window.onresize = "";
  },
  beforeDestroy() {
    const timers = this._copyTimers || {};
    Object.keys(timers).forEach((k) => clearTimeout(timers[k]));
  },
};
</script>

<style lang="less" scoped>
.toolboxPage {
  .contentBox {
    overflow-y: auto;

    .toolGrid {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;

      .toolCard {
        width: 180px;
        min-height: 130px;
        margin: 0 15px 15px 0;
        padding-top: 22px;
        padding-bottom: 16px;
        background-color: var(--bgPanel);
        border-radius: 6px;
        text-align: center;
        cursor: pointer;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
        transition: all 0.2s;

        i {
          font-size: 34px;
          color: var(--themeColor);
        }

        .toolName {
          margin-top: 10px;
          font-size: 15px;
          font-weight: bold;
          color: var(--textPrimary);
        }

        .toolDesc {
          margin-top: 6px;
          padding: 0 10px;
          font-size: 12px;
          color: var(--textSecondary);
          line-height: 1.5;
        }

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }

  .replacePartBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--bgPage);
    margin-top: -10px;

    .topPanel {
      background-color: var(--bgPanel);
    }

    .tipsBox {
      height: 30px;
      padding-left: 10px;
    }

    .tips {
      background-color: var(--tipsBg);
      height: auto;
      min-height: 30px;
      line-height: 30px;

      .title {
        font-weight: bold;
        color: #E6A23C;
      }

      .text {
        color: #E6A23C;
      }
    }

    .replacePartContent {
      display: flex;
      width: 1000px;
      padding: 10px 40px;

      .el-form {
        flex: 0.6;
      }

      .statusBox {
        flex: 0.4;
        width: 250px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        font-size: 16px;
        color: #fff;
      }

      .pass {
        background-color: #67C23A;
      }

      .fail {
        background-color: #f56c6c;
      }
    }
  }

  .pass1 {
    color: #67C23A;
  }

  .fail1 {
    color: #f56c6c;
  }

  .tableBox {
    flex: 1;
    margin-top: 10px;
    overflow: hidden;
    background-color: var(--bgPanel);
  }

  .toolCardBody {
    min-height: 300px;

    .toolEmpty {
      padding-top: 80px;
      text-align: center;

      i {
        font-size: 48px;
        color: var(--textPlaceholder);
      }

      p {
        margin-top: 15px;
        font-size: 14px;
        color: var(--textSecondary);
      }
    }
  }

  .psdQueryBox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .searchConditionBox {
      background-color: var(--bgPanel);
      padding: 10px 20px 0;
      margin-bottom: 2px;

      .el-form-item {
        margin-bottom: 10px;
      }
    }

    .tableBox {
      flex: 1;
      overflow: hidden;

      .el-table {
        font-size: 14px;
      }

      .bodyCell {
        position: relative;

        .el-link {
          font-size: inherit;
        }

        .textOverflow {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .copyBtn {
          display: none;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          padding: 0 2px;
          line-height: 1.2;
          cursor: pointer;
          color: var(--themeColor);
          background-color: var(--bgHover);
          border-radius: 2px;
          transition: color 0.2s, transform 0.2s;

          &:hover {
            color: var(--themeColorDark);
            transform: translateY(-50%) scale(1.2);
          }
        }

        &:hover .copyBtn {
          display: inline-block;
        }
      }
    }
  }

  .danger {
    color: #F56C6C;
  }
}
</style>
